<template>
  <div>
      <div class="container">
          <div class="box clearfix" style="width: 789px;display: inline-block;">
            <div >
              <div class="box-item" style="width: 789px;height: 475px;display: inline-block;">
                  <div class="inner titleChange">
                      <div class="newsList">
                          <div class="focusnews">
                            <div class="head">
                              <div class="li selected"><span class="lititle"><img src="/static/img/icon_bobao.png" />要闻播报</span></div>
                              <div class="li"><span class="lititle"><img src="/static/img/icon_zhengce.png" />政策法规</span></div>
                              <div class="li" style="width: 485px;text-align: right;" @click="$router.push(`/news/views/${Groups[0].plateId}`)"><span style="font-size: 13px;color: #FFFFFF;">更多要闻播报+</span></div>
                            </div>
                            <div class="pictxtlist">
                              <div class="list ellipsis show" style="display: block;" v-if="Groups[0]&&Groups[0].articles&&Groups[0].articles.length>0" >
                                <div class="pictxt ellipsis clear">
                                  <router-link :to="`/news/info/${Groups[0].articles[0].plateid}/${Groups[0].articles[0]._id}`"
                                    :title="Groups[0].articles[0].title">
                                    <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[0].articles[0].picsrc})`">
                                    </div>
                                  </router-link>
                                  <div class="title"><router-link :to="`/news/info/${Groups[0].articles[0].plateid}/${Groups[0].articles[0]._id}`"
                                      :title="Groups[0].articles[0].title"
                                      :style="`color:${Groups[0].articles[0].color?Groups[0].articles[0].color:'#000000'}; font-weight:${Groups[0].articles[0].weight?'bold':'500'}`">{{Groups[0].articles[0].title}}</router-link>
                                  </div>
                                  <div class="txt">
                                    {{Groups[0].articles[0].description}}
                                  </div>
                                </div>
                                 <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                                  <div class="li title" v-for="(article , index) in  Groups[0].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                                    :to="`/news/info/${article.plateid}/${article._id}`"
                                      :title="article.title"
                                      :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                                  </div>
                                 </div>
                              </div>
                              <div class="list ellipsis show" style="display: none;" v-if="Groups[1]&&Groups[1].articles&&Groups[1].articles.length>0" >
                                <div class="pictxt ellipsis clear">
                                  <router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                                    :title="Groups[1].articles[0].title">
                                    <div class="pic" :style="`background-image: url(${global.remoteIp}/uploads/${Groups[1].articles[0].picsrc})`">
                                    </div>
                                  </router-link>
                                  <div class="title"><router-link :to="`/news/info/${Groups[1].articles[0].plateid}/${Groups[1].articles[0]._id}`"
                                      :title="Groups[1].articles[0].title"
                                      :style="`color:${Groups[1].articles[0].color?Groups[1].articles[0].color:'#000000'}; font-weight:${Groups[1].articles[0].weight?'bold':'500'}`">{{Groups[1].articles[0].title}}</router-link>
                                  </div>
                                  <div class="txt">
                                    {{Groups[1].articles[0].description}}
                                  </div>
                                </div>
                                <div style="display: inline-block;width: 465px;padding: 20px;padding-top: 5px;padding-right: 5px;    position: absolute;">
                                  <div class="li title" v-for="(article , index) in  Groups[1].articles.slice(1)" :key="index"><span class="addtime">{{article.addtime.slice(0,10)}}</span><router-link
                                    :to="`/news/info/${article.plateid}/${article._id}`"
                                      :title="article.title"
                                      :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`" >{{article.title}}</router-link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div> 
          </div>
          <div class="right2">
            <el-tabs v-model="activeName" v-if="Groups[2].articles&&Groups[2].articles.length>0" >
              <el-tab-pane label="工作动态" name="first">
                <img src="/static/img/zhengshuchaxun.png" @click="$router.push(querypath)" style="width: 374px;height: 116px;"/>
                <div class="liselected" v-for="(article , index) in  Groups[2].articles.slice(0,3)" :key="index">
                  <div class="title"><router-link :to="`/news/info/${article.plateid}/${article._id}`"
                      :title="article.title" :style="`color:${article.color?article.color:'#000000'}; font-weight:${article.weight=='1'?'bold':'500'}`">{{article.title}}</router-link></div>
                      <span class="addtime1">{{article.addtime.slice(5,10)}}</span>
                      <p class="artdesp">{{article.description}}</p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
      </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
       Groups: [
        {
          name: "要闻播报", 
        },
        {
          name: "政策法规", 
        },
        {
          name: "工作动态", 
        }
      ],
      activeName: 'first',
      watchflag:0,
      querypath:global.isPhone()?'/inqCertM':'/inqCert'
    };
  },
  mounted() {
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-picsrc,-createdAt&limit=10`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles =res.data.data;
                this.$forceUpdate();
                this.watchflag++;
              }
            });
          break;
        }
      }
    }
  },
  watch:{
    watchflag(newVal){
      if(newVal==2)
      {
        $(function () {
          $('.pictxtlist').each(function () {
            var parentnote = $('.box-item');
            let eventype = parentnote.data('eventype');
            eventype = eventype ? eventype : 'click';
            $('.box-item').find('.head .li').on(eventype, function () {
              $(this).addClass('selected');
              $(this).siblings().removeClass('selected');
              var size = $(this).prevAll().size();
              parentnote.find('.pictxtlist .list').hide();
              parentnote.find('.pictxtlist .list').eq(size).show();
            });
          });
            jQuery(".txtMarquee-top").slide( { mainCell:".list",autoPlay:true,effect:'topMarquee',vis:9,interTime:50,opp:false,pnLoop:true,trigger: 'click',mouseOverStop:true});
          });
      }
    }
  },
   methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
    getYearMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}.${now.getMonth() + 1}`;
    },
  },
};
</script>
<style scoped>
.container{
  margin-top:40px;
}
.title-box .list{
  margin-top:35px;
}
.title-box .link{
   margin-top:35px;
   font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #B2B2B2;
  margin-right: 55px;
}
.linebox{
  width: 792px;
height: 1px;
background: #E0E0E0;
opacity: 0.5;
margin-top: 88px;
margin-left: 16px;
}
.ellipsis .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.focusnews .pictxtlist .list .li a::before{
  content: "";
  width: 8px;
height: 8px;
background: #BFBFBF;
border-radius: 4px;
display: inline-block;
left: -18px;
    position: relative;
    line-height: 24px;
}
.focusnews2 .head{
	height: 42px;
	background-color: #214b93;
	line-height: 45px;
	color: #fff;
}
.focusnews2 .head .column{
float: left;
    height: 54px;
    padding-left: 44px;
    background-repeat: no-repeat;
    background-image: url(/static/img/icon_bobao.png);
    position: absolute;
    top: -12px;
    width: 120px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 53px;

}
.focusnews2 .head .more{
	float: right;
	height: inherit;
	padding: 0 4px;
	font-size: 14px;
  line-height:42px;
}
.focusnews2 .head .more a{
color: #EEEEEE;
}
.focusnews2 .list{
	padding-top: 10px;
  height: 425px;
    overflow: hidden;
}
.focusnews2 .list .li{
	    padding: 15px 10px;
}
.focusnews2 .list .li .title{
	padding-left: 25px;
	background-repeat: no-repeat;
	background-position: 5px center;
	background-image: url(/static/img/dian.png);
	font-size: 16px;
}
.focusnews2 .list .li .title a{
	color: #861213;
}
.focusnews2 .list .li .txt{
	margin-top: 10px;
	padding-left: 40px;
	font-size: 12px;
	line-height: 20px;
	display: none;
}
.focusnews2 .list .li.selected .txt{
	display: block;
}
.right2{
	width: 374px;
	/* background-color: #fff; */
  display: inline-block;
  height: 463px;
  margin-top: 4px;
  margin-left: 39px;
  position: absolute;
}
.focusnews .head .li.selected .lititle{
background-image: url(/static/img/icon_yaowen.png);
    background-repeat: no-repeat;
    height: 66px;
    line-height: 54px;
    float: left;
    width: 152px;
}
/deep/ .el-tabs__item.is-active{
      color: #CF2C24;
}
/deep/ .el-tabs__item{
  height: 50px; 
  line-height: 50px;
  font-size: 22px;
}
/deep/ .el-tabs__active-bar{
  background-color: #CF2C24;
}
.liselected{
  width: 374px;
    height: 90px;
    background: #FAFAFA;
    margin-top: 9px;
}
.liselected .title{
      color: #333333;
    font-size: 16px;
    font-weight: bold;
    margin-left: 11px;
    padding-top: 19px;
    width: 261px;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.addtime1{
      float: right;
    /* position: absolute; */
    margin-top: -15px;
    font-size: 16px;
    color: #999999;
    margin-right: 30px;
}
.artdesp{
width: 330px;
height: 13px;
font-size: 13px;
color: #666666;
    margin-top: 19px;
    margin-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
